import { render, staticRenderFns } from "./FloatSpan.vue?vue&type=template&id=d42d3774&"
import script from "./FloatSpan.vue?vue&type=script&lang=js&"
export * from "./FloatSpan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FloatSpan.vue"
export default component.exports